import { FETCH_STOCK_FAILURE, FETCH_STOCK_REQUEST, FETCH_STOCK_SUCCESS } from './stock.actionsType';

export const STOCK = 'stock';

let initialState = {
    loading: false,
    stockInfo: [],
    errorMessage: '',
    iperrorMessage: ''
};

export let stockReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_STOCK_REQUEST:
        case FETCH_STOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                stockInfo: updatePayload
            };
        case FETCH_STOCK_FAILURE:
        default:
            return state;
    }
};
